import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';
import { InternalOrganizationType } from '@/bundle/_MasterAdmin/types/types';

export type EditInternalOrganizationDetailsPayloadType = {
  name: string;
};

export const editInternalOrganizationDetailsApi = async (
  data: EditInternalOrganizationDetailsPayloadType
): Promise<ApiResponseType<InternalOrganizationType>> => {
  const uri = '/organization/internal/';

  return authApiService.PATCH(uri, data);
};
